export function getCores() {
    return navigator.hardwareConcurrency;
}
